import React, { Component } from 'react'
import { Alert, Button, Col, Form, message } from 'antd'
import AddressList from '../../Common/Contacts/AddressList'
import _ from 'lodash'

const FormItem = Form.Item

class Address extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let res = await this.props.handleSubmit()
        res && message.success('Updated')
      } else {
        message.error('Invalid')
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      formItemLayout,
      contact,
      loading,
      error,
      fetching,
      handleChange,
      handleAdd,
      handleDefault,
      handleRemove,
    } = this.props
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 4,
        },
      },
    }
    console.log(123, { error })
    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <AddressList
          list={_.get(contact, 'address', [])}
          handleChange={handleChange}
          fetching={fetching}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />

        <Col offset={12} span={12} style={{ marginRight: 0 }}>
          <FormItem {...tailFormItemLayout} style={{ paddingTop: 10 }}>
            <p style={{ textAlign: 'right' }}>
              <Button loading={loading} type="primary" htmlType="submit">
                Update
              </Button>
            </p>
            {error.key !== '' ? (
              <Alert
                _key={error._key}
                message={error.message === '' ? 'failed!' : error.message}
                type="error"
                closable
              />
            ) : null}
          </FormItem>
        </Col>
      </Form>
    )
  }
}

Address.propTypes = {}
Address.defaultProps = {}

const WrappedRegistrationForm = Form.create()(Address)

export default WrappedRegistrationForm
